import {ActionType, createAction} from 'typesafe-actions';
import {PrefixDTO} from '../../../../interfaces/PrefixDTO';
import {PrefixFilterOptions} from '../../../../interfaces/PrefixFilterOptions';

export const viewApiServiceLoadPrefixDataCompleted = createAction(
    'VIEW_API_SERVICE_LOAD_PREFIX_DATA_COMPLETED',
    (action) => (prefixes: PrefixDTO[]) => action({prefixes}),
);

export const viewApiServiceLoadPrefixV2DataCompleted = createAction(
    'VIEW_API_SERVICE_LOAD_PREFIX_V2_DATA_COMPLETED',
    (action) => (prefixType: keyof PrefixFilterOptions, prefixes: string[]) => action({prefixes, prefixType}),
);

export const viewerApiServiceLoadPrefixDataFailedWithUnauthorizedError = createAction(
    'VIEWER_API_SERVICE_LOAD_PREFIX_DATA_FAILED_WITH_UNAUTHORIZED_ERROR',
    (action) => () => action({}),
);

export const viewerApiServiceLoadPrefixDataFailedWithUnexpectedError = createAction(
    'VIEWER_API_SERVICE_LOAD_PREFIX_DATA_FAILED_WITH_UNEXPECTED_ERROR',
    (action) => () => action({}),
);

export type ViewerApiServiceLoadPrefixData =
    | ActionType<typeof viewApiServiceLoadPrefixDataCompleted>
    | ActionType<typeof viewApiServiceLoadPrefixV2DataCompleted>
    | ActionType<typeof viewerApiServiceLoadPrefixDataFailedWithUnauthorizedError>
    | ActionType<typeof viewerApiServiceLoadPrefixDataFailedWithUnexpectedError>;
